import { NavLink, useLocation } from "react-router-dom";
import models from "../../model-declaration";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import { useRole } from "../../context/role/RoleContext";

const Sidebar = () => {
  const loaction = useLocation();
  const { state } = useRole();

  return (
    <aside className="bg-background shadow-custom-soft rounded-lg text-darkText h-full max-h-full overflow-auto xl:p-5 p-3">
      <ul className="flex flex-col gap-1">
        <NavLink
          to={`/dashboard`}
          className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
            loaction.pathname.split("/")[1] === "dashboard"
              ? "bg-primary text-white"
              : ""
          }`}
        >
          Dashboard
        </NavLink>
        {(state?.role?.employee?.read || state?.role?.employee?.write) && (
          <NavLink
            to={`/admin/users/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[2] === "users"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            employees
          </NavLink>
        )}
        {state?.role?.type === "admin" && (
          <NavLink
            to={`/admin/roles/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[2] === "roles"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            employee Roles
          </NavLink>
        )}

        {(state?.role?.company?.read || state?.role?.company?.write) && (
          <NavLink
            to={`/company/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "company"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Company
          </NavLink>
        )}

        {(state?.role?.product?.read || state?.role?.product?.write) && (
          <NavLink
            to={`/product/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "product"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            product
          </NavLink>
        )}

        {(state?.role?.lead?.read || state?.role?.lead?.write) && (
          <NavLink
            to={`/lead/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "lead"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Lead
          </NavLink>
        )}

        {(state?.role?.lead_activity?.read ||
          state?.role?.lead_activity?.write) && (
          <NavLink
            to={`/lead-activity/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "lead-activity"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Lead activity
          </NavLink>
        )}

        {(state?.role?.customer?.read || state?.role?.customer?.write) && (
          <NavLink
            to={`/customer/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "customer"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Customer
          </NavLink>
        )}

        {(state?.role?.customer_activity?.read ||
          state?.role?.customer_activity?.write) && (
          <NavLink
            to={`/customer-activity/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "customer-activity"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            customer activity
          </NavLink>
        )}

        {(state?.role?.order?.read || state?.role?.order?.write) && (
          <NavLink
            to={`/orders/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "orders"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            orders
          </NavLink>
        )}

        {(state?.role?.payment?.read || state?.role?.payment?.write) && (
          <NavLink
            to={`/payment/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "payment"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Payment
          </NavLink>
        )}

        {(state?.role?.payment?.read || state?.role?.payment?.write) && (
          <NavLink
            to={`/employee-request/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "employee-request"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            employee request
          </NavLink>
        )}

        {(state?.role?.marketing_material?.read ||
          state?.role?.marketing_material?.write) && (
          <NavLink
            to={`/marketing-materials-category/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "marketing-materials-category"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            marketing materials category
          </NavLink>
        )}

        {(state?.role?.marketing_material?.read ||
          state?.role?.marketing_material?.write) && (
          <NavLink
            to={`/marketing-materials/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "marketing-materials"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            marketing materials
          </NavLink>
        )}

        {(state?.role?.tile_layer?.read || state?.role?.tile_layer?.write) && (
          <NavLink
            to={`/tile-layers/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "tile-layers"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Tile layers
          </NavLink>
        )}

        {(state?.role?.expense?.read || state?.role?.expense?.write) && (
          <NavLink
            to={`/expense/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "expense"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            Expense
          </NavLink>
        )}

        {(state?.role?.settings?.read || state?.role?.settings?.write) && (
          <NavLink
            to={`/designation/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "designation"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            designation
          </NavLink>
        )}

        {(state?.role?.settings?.read || state?.role?.settings?.write) && (
          <NavLink
            to={`/department/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "department"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            department
          </NavLink>
        )}

        {(state?.role?.settings?.read || state?.role?.settings?.write) && (
          <NavLink
            to={`/state/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "state"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            state
          </NavLink>
        )}

        {(state?.role?.settings?.read || state?.role?.settings?.write) && (
          <NavLink
            to={`/city/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === "city"
                ? "bg-primary text-white"
                : ""
            }`}
          >
            city
          </NavLink>
        )}

        {models?.map((model, index) => (
          <NavLink
            key={index}
            to={`/${model?.tableName}/list`}
            className={`block p-2 hover:bg-gray-200 hover:text-darkText rounded capitalize ${
              loaction.pathname.split("/")[1] === model?.tableName
                ? "bg-primary text-white"
                : ""
            }`}
          >
            {formatUnderscoreToSpace(model?.tableName)}
          </NavLink>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
